/* global _ */
import {name, mixins, props, data, EventBus} from './config'

export default {
  name,
  mixins,
  props,

  data() {
    return {
      ...data,
      items: null,
      order: null,
      customStep: null,
      disableBillingForm: false,
      viewPaymentDetails: false,
    }
  },

  watch: {
    cartStep(stepName) {
      this.lazyScrollTo('.re-page')
    }
  },

  created() {
    this.setCostDetails({})
    this.allowLocationCheckout(this.useLocationBasedCart)
    this.customStep = this.$$debug && this.step
    this.setCartStep(this.customStep || 'cart')

    EventBus.$on('cart.unauthenticated', () => {})

    EventBus.$once('cart.validated', x => {
      this.setCostDetails(x)
      this.setValidationError()
    })

    EventBus.$on('cart.validate', async () => {
      this.validateRepeatCount = 0
      await this.validateCart()
    })

    EventBus.$on('cart.paying', () => {
      this.items = this.currentCartItems
    })
    EventBus.$on('cart.paid', order => {
      //this.stopTimer()
      this.order = order
      this.clearCartItems()
    })
    EventBus.$on('showPaymentDisabledDetails', () => {
      this.customStep = 'billing'
      this.disableBillingForm = true
      this.viewPaymentDetails = true
      this.setCartStep('billing')
    })

  },

  computed: {
    showCartEmpty() {
      return !this.customStep && _.isEmpty(this.order) && this.currentCartIsEmpty
    },
    showCartStep() {
      return this.isCustomCartStep('cart') || (this.cartStep === 'cart' && !this.currentCartIsEmpty)
    },
    showBillingStep() {
      return this.isCustomCartStep('billing') || (this.cartStep === 'billing' && !this.currentCartIsEmpty)
    },
    showFinalStep() {
      return this.isCustomCartStep('final') || (this.cartStep === 'final' && !_.isEmpty(this.order))
    }
  },

  methods: {
    isCustomCartStep(step) {
      return this.customStep && this.customStep === step
    },
  },
}
